<template>
    <div>
        <v-form ref="form" :errors="serverValidations" :validate="validateForm" @submit="handleSubmit"
            :readonly="isRegistering">
            <template scope="api">

                <v-form-input field="activityType" select :items="activityTypes" label="Вид деятельности"
                    v-margin.bottom="2" @input="changeActivityType" />

                <v-form-input v-if="activityType == 1" field="orgType" select :items="orgTypes" label="Форма собственности"
                    v-margin.bottom="2" />

                <v-form-input v-if="activityType == 1" field="companyName" label="Название компании" v-margin.bottom="2" />

                <v-form-input field="fio" label="ФИО" v-margin.bottom="2" />
                <v-form-input field="email" label="Email" v-margin.bottom="2" type="email" @input="handleInputEmail" />

                <v-form-input field="password" label="Пароль" type="password" maxlength="16"
                    caption="Не менее 6 символов" v-margin.bottom="1" />

                <v-form-input field="phoneNumber" mask="phone" label="Номер телефона" v-margin.bottom="2" />

                <v-form-checkbox field="agreementAccepted" data="true" :readonly="isRegistering">
                    <template slot="label" scope="label">
                        <v-text type="caption">
                            Нажимая на кнопку «Зарегистрировать», вы даёте согласие на обработку
                            <br />
                            <v-link to="https://exbico.ru/page97982866.html" target="_blank">
                                персональных данных
                            </v-link>
                        </v-text>
                    </template>
                </v-form-checkbox>

                <div v-margin.bottom="4" v-margin.top="2">
                    <v-spinner block :active="isRegistering">
                        <v-button :disabled="api.isInvalid || isDisabled" type="submit" primary block>
                            ЗАРЕГИСТРИРОВАТЬ
                        </v-button>
                    </v-spinner>

                    <div v-if="serverError" v-padding.top="1">
                        <v-text danger>
                            {{ serverError }}
                        </v-text>
                    </div>
                </div>
            </template>
        </v-form>
        <v-modal :active="isShowConfirm" @close="handleModalClose">
            <div v-padding="2">
                <div v-margin.bottom="1">
                    <v-text type="title" v-margin.bottom="2"> Спасибо! Ваша заявка принята. </v-text>
                </div>
                <div v-margin.bottom="1">
                    <v-text v-margin.bottom="2">
                        Мы свяжемся с вами в ближайшее время.
                    </v-text>
                </div>

                <div v-text-align.right v-margin.top="1">
                    <v-button flat @click="handleModalClose"> Закрыть </v-button>
                </div>
            </div>
        </v-modal>
    </div>
</template>
<script>
import { vButton } from '../baseComponents';
import FormPhoneVerify from '../FormPhoneVerify';
import { validateRegisterForm } from './validations';
import { isRequired, isEmail } from '../../../services/validator';
import { ORG_TYPES } from "./constants";

export default {
    name: 'register-form',
    props: {
        onRegister: Function,
        onVerifyEmail: Function,
        regions: Array,
        orgTypes: Array,
        timer: Number,
    },
    components: {
        vButton,
        FormPhoneVerify,
    },
    data() {
        return {
            isRegistering: false,
            isVerified: false, // true
            // phoneVerifyMode: 'phone',
            serverError: undefined,
            serverValidations: {},
            isVerificationEmail: false,
            isShowConfirm: false,
            activityTypes: [
                { name: "Компания", value: ORG_TYPES.Company },
                { name: "ИП", value: ORG_TYPES.IndividualEntrepreneur },
                { name: "Самозанятый", value: ORG_TYPES.SelfEmployed }
            ],
            activityType: 0
        }
    },
    computed: {
        isRenderPhoneVerify() {
            return false;
        },
        isDisabled() {
            return this.isRegistering || this.isVerificationEmail || this.isNotEmptyValidations;
        },
        isNotEmptyValidations() {
            return Object.values(this.serverValidations).some((err) => Boolean(err));
        }
    },
    methods: {
        changeActivityType(target) {
            this.activityType = target.value;
        },
        validateForm(values) {
            return validateRegisterForm(values, this.isVerified);
        },
        handleInputEmail(email) {
            if (isRequired(email) || isEmail(email)) {
                return;
            }

            this.isVerificationEmail = true;
            this.serverValidations = {
                ...this.serverValidations,
                email: undefined,
            };

            this.onVerifyEmail(encodeURIComponent(email.trim()))
                .then((res) => {
                    this.isVerificationEmail = false;
                })
                .catch((res) => {
                    this.serverValidations = {
                        ...this.serverValidations,
                        email: res.message,
                    };
                    this.isVerificationEmail = false;
                });
        },
        handleModalClose() {
            this.$router.push('/');
        },
        handleSubmit(values) {
            if (this.isDisabled) {
                return;
            }

            this.isRegistering = true;
            this.serverError = undefined;
            this.serverValidations = {};
            this.onRegister({
                ...values,
                agreementAccepted: values.agreementAccepted[0] === "true",
                activityType: values.activityType.value,
                orgType: values.orgType && values.orgType.id
            })
                .then((res) => {
                    this.isRegistering = false;
                    this.$router.push('/');
                })
                .catch((res) => {
                    this.isRegistering = false;
                    this.serverError = res.message;

                    if (res.status === 400) {
                        this.serverValidations = res.data;
                    }
                });
        },

        handleReset(api) {
            api.setTouched('phone', false);
            api.setValue('phone', '');

            this.isVerified = false;
            // this.phoneVerifyMode = 'phone';
        }
    }
}
</script>



// WEBPACK FOOTER //
// RegisterForm.vue?08ddbf8a